module.exports = __webpack_public_path__ + "static/img/zzc.0d91412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzc.jpg
// module id = IvAp
// module chunks = 2